import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ValidationService } from '../services/validation.service';


export class ControlMessagesComponent implements OnInit {

   control : FormControl;
   message : string;
   validator : string;

  private _errorMessage: string | null | undefined;

  ngOnInit() {}

  isInvalid(): boolean {
    return this.control && this.control.touched && !this.control.valid;
  }

  hasError(validator : string) {
    return this.control && this.control.hasError(validator) && this.control.touched;
  }

  get errorMessage() {
    if (this.validator) {
      this._errorMessage = this.hasError(this.validator) ? this.message || ValidationService.getErrorMessage(this.validator) : null;
    } else if (this.control.errors) {
      // iterate all validators and display first error message
      for (const propertyName in this.control.errors) {
        if (this.hasError(propertyName)) {
          this._errorMessage = this.message || ValidationService.getErrorMessage(propertyName);
          break;
        }
      }
    }
    return this._errorMessage;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-control-messages',
  template: `
<div *ngIf="isInvalid()" class="help-block">{{ errorMessage }}</div>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'control': [{ type: Input },],
'message': [{ type: Input },],
'validator': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
